import React from 'react';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import styles from './ImportErrorsMessage.module.scss';
import WarningIcon from '@lmt/unicorn-shared/app/icons/exclamation_mark_red.svg?react';

interface Props {
  importErrors?: { [p: string]: string };
}

export const ImportErrorsMessage: React.FC<Props> = (props) => {
  const i18next = useScopedTranslation(
    'patients.form.edit_patient.import_errors',
  );

  if (!props.importErrors) {
    return null;
  }
  const errors = [];
  for (const [field, errorValue] of Object.entries(props.importErrors)) {
    errors.push(
      `${field} (${i18next.t('before_fix_value', {
        value: errorValue,
      })})`,
    );
  }
  const message = `${i18next.t('title')} ${errors.join(', ')}`;
  return (
    <div className={styles.importErrorsContainer}>
      <div className={styles.importErrorsText}>
        <WarningIcon className={styles.warningIcon} />
        {message}
      </div>
    </div>
  );
};
